import { createApp } from 'vue';
import App from './App.vue';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import axios from "axios";
import router from "../router/router.js";
import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';
import store from '../src/store/index.js';
import { createPinia } from 'pinia';
import print from "vue3-print-nb";
import 'primeicons/primeicons.css'
import Aura from '@primeuix/themes/aura';
import '@/assets/scss/style.min.css'
import '@/assets/scss/design-system.css'
import '@/assets/css/themes/dark.css'
import '@/assets/css/themes/light.css'
import { initTheme } from '@/services/themeService.js'

initTheme()

axios.defaults.baseURL = localStorage.getItem("api_base_url") || "https://api.moustafahosney.com/api";
// axios.defaults.baseURL = "http://192.168.1.26:8000/api";

const token = localStorage.getItem("token");
if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
}
const app = createApp(App);
app.config.globalProperties.axios = axios;
const pinia = createPinia();
app.use(pinia);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            darkModeSelector: false,
            cssLayer: false
        }
    }
});
app.use(router);
app.use(print);
app.use(store);
app.directive('tooltip', Tooltip);
app.mount('#app');